import { render, staticRenderFns } from "./stampsAdd.vue?vue&type=template&id=4ecf563e&scoped=true&"
import script from "./stampsAdd.vue?vue&type=script&lang=js&"
export * from "./stampsAdd.vue?vue&type=script&lang=js&"
import style0 from "./stampsAdd.vue?vue&type=style&index=0&id=4ecf563e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf563e",
  null
  
)

export default component.exports